import * as React from "react"
import Img from "gatsby-image"
import TelegramSvg from "../images/telegram.inline.svg"
import WhatsappSvg from "../images/whatsapp.inline.svg"
import * as styles from "./HomeAbout.module.css"

const HomeAbout = ({ aboutRef, isAboutPlay, imgIcon, imgBack }) => (
  <div id="about" className={styles.overviewSection} ref={aboutRef}>
    <div className="container">
      <div className="title">О Даше и марафонах</div>
      <h2 className="large-heading heading-width">Обо мне</h2>
      <div className="author-wrap">
        <div className="author">
          <Img fluid={imgIcon} className="blog-image-wrap" />
        </div>
        <div className="author-name-wrap">
          <p className="author-name">Дарья Старикова</p>
          <div className="detail">Фитнес-инструктор</div>
        </div>
      </div>
      <div className="grid-content-right">
        <ul>
          <li>
            Стаж работы фитнес тренером <b>более 7 лет</b>;
          </li>
          <li>
            <b>10 лет</b> в профессиональном спорте;
          </li>
          <li>
            Многократный победитель и призер чемпионатов <b>Беларуси</b> по
            бегу;
          </li>
          <li>
            <b>Высшее</b> образование, <b>диплом</b> специалиста в области
            физической культуры;
          </li>
          <li>
            <b>Диплом</b> инструктора по фитнесу;
          </li>
          <li>
            <b>Диплом</b> фитнес нитрициолога;
          </li>
          <li>
            Множество <b>сертификатов</b>.
          </li>
        </ul>
      </div>
      <div className="w-layout-grid social-grid">
        <a
          href="https://t.me/daryia1177"
          target="_blank"
          rel="noreferrer"
          className="social-icon-block w-inline-block"
        >
          <TelegramSvg className="social-logo" />
          <div className="social-name">Telegram</div>
        </a>
        <a
          href="https://wa.me/375293944666"
          target="_blank"
          rel="noreferrer"
          className="social-icon-block w-inline-block"
        >
          <WhatsappSvg className="social-logo" />
          <div className="social-name">WhatsApp</div>
        </a>
      </div>
    </div>
    <div style={{ height: "auto" }} className="bg-block-blue">
      <Img fluid={imgBack} />
    </div>
  </div>
)

export default HomeAbout
